import axios from 'axios';
import { routes } from '../utils/routes';

const sendChatCategory = (chatCategory,freetext, config) => {
	return axios.post(`${config.xApiUrl}${routes.AGENT_FEEDBACK}`, chatCategory, {
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => response);
};

const sendTransferNote = (config,data) => {
	return axios.post(`${config.xApiUrl}${routes.AGENT_NOTE}`, data, {
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => response);
};

const getContactTranscript = (config) => {
	const url = `${config.xApiUrl}${routes.CONTACTS_TRANSCRIPT}/${config.contactId}` +
		`?source=raw` +
		`&clientApiKey=${config?.clientApiKey || ''}` +
		`&getPrevious=${config?.getPrevious || 0}`;
	return axios.get(url,{
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response?.data?.data;
	});
};

const getContactData = (params, config) => {
	const {cmd, apiKey, sessionId} = params;
	const url = `${config.xApiUrl}${routes.CONTACT_DATA}` +
		`?cmd=${cmd}` +
		`&apiKey=${apiKey}` +
		`&sessionId=${sessionId}`;
	return axios.get(url,{
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response?.data;
	});
};

const sendTemplateUsageStatistic = (params, config) => {
	const {contactId, agentUsername, templateId, isModified} = params;
	if (!config?.instanceId || !contactId || !templateId) {
		return new Promise(resolve => resolve(null));
	}
	const postData = {
		contactId: contactId,
		agentUsername: agentUsername,
		instanceId: config.instanceId,
		templateId: templateId,
		isModified: isModified
	};
	return axios.post(`${config.xApiUrl}${routes.TEMPLATE_USAGE_STATISTIC}`, postData, {
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => response);
};

const sendEndSessionBySessionId = (data, {url = 'https://va-uat-api.odeza.com/v1', token}) => {
	return axios.post(`${url}${routes.END_SESSION}`, data, {
		headers: { 'Authorization': token },
	})
};

const getAgentJwtToken = (params, config) => {
	const {provider, providerToken, tokenType, isOld} = params;
	const url = `${config.xApiUrl}${routes.AGENT_AUTH}` +
		`?provider=${provider}` +
		`&provider_token=${providerToken}` +
		(tokenType ? `&token_type=${tokenType}` : '') +
		`&t=true` +
		(config.xApiClientId ? `&practice_id=${config.xApiClientId}` : '') +
		(config.instanceId ? `&instance_id=${config.instanceId}` : '') +
		(isOld ? `&old=${isOld}` : '');
	return axios.get(url,{
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response?.data;
	});
}

const validateAgentRoutingProfile = (config) => {
	if (!config?.xApiToken) {
		return new Promise(resolve => resolve(null));
	}
	const url = `${config.xApiUrl}${routes.AGENT_AUTH}?cmd=validate-routing-profile` +
		(config.xApiClientId ? `&practice_id=${config.xApiClientId}` : '') +
		(config.instanceId ? `&instance_id=${config.instanceId}` : '');
	return axios.get(url,{
		headers: {
			'Authorization': `Bearer ${config?.xApiToken}`,
			'Content-Type': 'application/json',
		},
	}).then(response => response);
}

const isTranslationsEnabled = (practiceId, queueId) => {

	console.log("Practice Id: ", practiceId);
	console.log("Queue Id: ", queueId);

   	return axios.get(`https://ac-translate-uat-api.odeza.com/clients/${practiceId}/queues/${queueId}`, {
		headers: {
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response.data;
	});
}

const getTranslatedMessage = (practiceId, queueId, sourceLang, targetLang, message) => {
	const data = {
		"message": message,
		"source_lang_code": sourceLang,
		"target_lang_code": targetLang
	}

	return axios.post( `https://ac-translate-uat-api.odeza.com/clients/${practiceId}/queues/${queueId}`, data, {
		headers: {
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response.data;
	});
}

const storeTranslatedMessage = (params) => {
	const data = {
		"instance_id": params.instanceId,
		"contact_id": params.contactId,
		"message_id": params.messageId,
		"source_language": params.sourceLang,
		"source_message": params.sourceMessage,
		"result_language": params.resultLang,
		"result_message": params.resultMessage
	}

	return axios.post( `https://ac-translate-uat-api.odeza.com/clients/${params.practiceId}/store`, data, {
		headers: {
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response.data;
	});
}

const loadTranslatedMessages = (params) => {
	// const data = {
	// 	"instance_id": params.instanceId,
	// 	"contact_id": params.contactId
	// }

	return axios.get( `https://ac-translate-uat-api.odeza.com/clients/${params.practiceId}/store`, {
		params: params,
		headers: {
			'Content-Type': 'application/json',
		},
	}).then(response => {
		return response.data;
	});
}

const getQuickConnectsMetrics = (config, data) => {
	return axios.post(`${config.xApiUrl}${routes.AGENT_METRICS}`, data, {
		headers: {
			'x-api-key': config?.xApiKey,
			'Content-Type': 'application/json',
		},
	});
};

export default {
	sendChatCategory,
	getContactTranscript,
	getContactData,
	sendTemplateUsageStatistic,
	sendTransferNote,
	sendEndSessionBySessionId,
	getAgentJwtToken,
	validateAgentRoutingProfile,
	getTranslatedMessage,
	isTranslationsEnabled,
	storeTranslatedMessage,
	loadTranslatedMessages,
	getQuickConnectsMetrics,
};
